import { render } from "./deactive-customers.vue?vue&type=template&id=0c927123"
import script from "./deactive-customers.vue?vue&type=script&lang=js"
export * from "./deactive-customers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__